export default __webpack_public_path__ + "static/media/6.bb2b38e8.jpg";